import { AppShell, Paper, Tabs } from '@mantine/core';
import { AsideBattleList } from './AsideBattleList';
import { AsideChallengesList } from './AsideChallengesList';
import { AsideChat } from './AsideChat';
import { AsideLogin } from './AsideLogin';
import classes from './AsideTab.module.css';
import { AsideTabControl } from './AsideTabControl';
export const Aside: React.FC = () => {
  return <AppShell.Aside p="md" pt={0} withBorder={false} style={{
    zIndex: 1
  }}>
      <Paper bg="var(--navbar-bg-color)" h="100%" pos="relative" style={{
      overflow: 'hidden'
    }}>
        <Tabs variant="pills" defaultValue="chat" classNames={{
        tab: classes.tab
      }}>
          <AsideTabControl />

          <Tabs.Panel value="chat">
            <AsideChat />
            <AsideLogin />
          </Tabs.Panel>

          <Tabs.Panel value="battle">
            <AsideBattleList />
          </Tabs.Panel>

          <Tabs.Panel value="challenges">
            <AsideChallengesList />
          </Tabs.Panel>
        </Tabs>
      </Paper>
    </AppShell.Aside>;
};